var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWillPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#2df788"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 18.8125C12.25 16.6379 14.0129 14.875 16.1875 14.875C18.3621 14.875 20.125 16.6379 20.125 18.8125V20.125H12.25V18.8125Z",
    fill: "#e2d1fa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 14.875H36.25C38.4591 14.875 40.25 16.6659 40.25 18.875V42H23.25C21.0409 42 19.25 40.2091 19.25 38V14.875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 37.125C43.75 39.3341 41.9591 41.125 39.75 41.125L25.375 41.125L25.375 35.875L43.75 35.875L43.75 37.125Z",
    fill: "#e2d1fa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7591 34.7375H40.8151V19.075C40.8151 15.8375 38.1309 13.125 34.9271 13.125H16.0508C13.4531 13.125 11.375 15.225 11.375 17.85V20.3875C11.375 20.9125 11.7214 21.2625 12.2409 21.2625H18.9082V39.4625C18.9082 41.3875 20.4668 42.875 22.2852 42.875H39.9492C42.8932 42.875 44.625 40.5125 44.625 38.15V35.6125C44.625 35.175 44.1921 34.7375 43.7591 34.7375ZM13.1068 17.85C13.1068 16.1875 14.4056 14.875 16.0508 14.875C17.696 14.875 18.9948 16.1875 18.9948 17.85V19.5125H13.1068V17.85ZM25.2292 35.6125V38.15C25.2292 39.375 24.3633 41.125 22.2852 41.125C21.3327 41.125 20.64 40.3375 20.64 39.4625V20.3875V17.85C20.64 16.7125 20.207 15.75 19.6009 14.875H34.9271C37.1784 14.875 39.0833 16.8 39.0833 19.075V34.7375H26.0951C25.5755 34.7375 25.2292 35.175 25.2292 35.6125ZM42.8932 38.15C42.8932 39.375 42.0273 41.125 39.9492 41.125H25.9219C26.6146 40.25 26.9609 39.2 26.9609 38.15V36.4875H42.8932V38.15Z",
    fill: "#090927"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3607 21H34.1393C34.6557 21 35 20.65 35 20.125C35 19.6 34.6557 19.25 34.1393 19.25H25.3607C24.8443 19.25 24.5 19.6 24.5 20.125C24.5 20.65 24.9303 21 25.3607 21Z",
    fill: "#090927"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2172 25.375H32.5328C32.9631 25.375 33.25 25.025 33.25 24.5C33.25 23.975 32.9631 23.625 32.5328 23.625H25.2172C24.7869 23.625 24.5 23.975 24.5 24.5C24.5 25.025 24.8586 25.375 25.2172 25.375Z",
    fill: "#090927"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4324 29.75H34.9426C35.502 29.75 35.875 29.4 35.875 28.875C35.875 28.35 35.502 28 34.9426 28H25.4324C24.873 28 24.5 28.35 24.5 28.875C24.5 29.4 24.9662 29.75 25.4324 29.75Z",
    fill: "#090927"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWillPlan);
export default __webpack_public_path__ + "static/media/will-plan.9cf7219363ee640da71c54fca65f7de1.svg";
export { ForwardRef as ReactComponent };